import { render, staticRenderFns } from "./twoIndex.vue?vue&type=template&id=a87d45f0&scoped=true&"
import script from "./twoIndex.vue?vue&type=script&lang=js&"
export * from "./twoIndex.vue?vue&type=script&lang=js&"
import style0 from "./twoIndex.vue?vue&type=style&index=0&id=a87d45f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87d45f0",
  null
  
)

export default component.exports